module.exports = __webpack_public_path__ + "static/media/设置.ef176ee9.svg";